// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AZ-n","placeholdersHeader":"styles_placeholdersHeader__1LHxo","editorStyle":"styles_editorStyle__1ROLo","placeholdersBox":"styles_placeholdersBox__2KMWX"};